<template>
<div >
    <!-- Error/Status Popups -->
    <div class="error_popup popup-desktop" v-if="submitting" style="display:block;">
        <div class="error_box error-pop-desk">
            <img src="@/assets/images/info_icon_plan.png" loading="lazy" alt="" class="image-496">
            <div class="text-block-1101">Please wait...</div>
            <div class="text-block-1102">Submitting form!</div>
        </div>
    </div>

    <div class="error_popup popup-desktop" v-if="showDisqualify" style="display:block;">
        <div class="error_box error-pop-desk">
            <div class="text-block-1101" style="font-size: 16px;font-weight: bold;">We Cannot Proceed</div>
            <div class="text-block-1102" style="font-size: 14px;">
                {{ disqualifyMessage || 'Based on your responses, we cannot proceed with your application at this time.' }}
                <br /><br />
                If you believe there was an error in your submission, please click "Resubmit Form" below to update your information.
                <br /><br />
                If you prefer not to proceed, you can select "Process Refund" to request a refund.
            </div>
            <div class="button-model-yes-no new-yes-no" style="display: flex;justify-content: center;width: 100%;">
                <a href="#" class="button-107 w-button" @click.prevent="showDisqualify=false;" style="background-color: var(--light-green);color: #fff; text-align: center;">Resubmit Form</a>&nbsp;&nbsp;&nbsp;
                <a href="#" class="button-107 w-button" style="background-color: var(--light-blue);color: #fff; text-align: center;" @click.prevent="disqualifyUserAndRefund()">Process Refund</a>
            </div>
        </div>
    </div>

    <!-- Header/Navigation -->
    <section>
        <div class="top-nav-div">
            <div class="top-nav-elements">
                <a href="#" class="link-block-42 w-inline-block">
                    <img :src="require('@/assets/images/NewSelf_Logo-p-500.png')" sizes="(max-width: 479px) 100vw, 84.03125px" :srcset="`${require('@/assets/images/NewSelf_Logo-p-500.png')} 500w, ${require('@/assets/images/NewSelf_Logo-p-500.png')} 800w`" loading="lazy" class="image-294">
                </a>
                <div class="form-nav-div">
                    <a href="#" class="back-link w-inline-block" @click.prevent="goBack()">
                        <div class="text-block-507">&lt;-</div>
                    </a>
                    <div class="form-progress-div">
                        <div>
                            <div class="text-block-508">Step <strong>3</strong> of <strong>3</strong></div>
                        </div>
                        <div class="form-precent-div">
                            <div class="text-block-509"><strong>{{ Math.round(((currentQuestionIndex + 1) / questions.length) * 100) }}%</strong> Complete</div>
                        </div>
                    </div>
                </div>
                <div class="div-block-1442">
                    <div class="text-block-505"></div>
                </div>
            </div>
        </div>
    </section>

    <!-- Question Content -->
    <div v-if="gettingDetails">
        <div class="dotted-loader"></div>
        <div class="h-80"></div>
    </div>
    <section class="section-7" v-else>
        <div class="questions-div setsizeonphone">
            <div class="question-content">
                <div class="question-container" v-if="currentQuestion">
                    <div class="question-div-2">
                        <!-- Question Header/Label -->
                        <div class="text-block-513" v-if="currentQuestion.question_type === 'dose_optimization'">Customize Your Dosage Schedule for {{ productPurchased }}: </div>
                        <div class="text-block-513" v-else v-html="currentQuestion.label"></div>
                        <div class="form-subs" v-if="currentQuestion.description" :class="{'consent-text' : currentQuestion.question_type === 'consent'}" v-html="currentQuestion.description"></div>

                        <div class="felix-form-block w-form" v-if="currentQuestion.question_type === 'consent'">
                            <a href="#" class="link-block-30 w-inline-block acceptbutton" @click.prevent="handleAnswer('YES, I CONSENT to being treated with GLP-1 agonists. I have reviewed the risks and benefits above.')">
                                <div>
                                    <div class="text-block-545" style="color:#fff">YES, I CONSENT to being treated with GLP-1 agonists. I have reviewed the risks and benefits above.</div>
                                </div>
                            </a>
                            <a href="#" class="link-block-30 w-inline-block rejectconbutton" @click.prevent="handleAnswer('NO, I DO NOT consent to being treated with a GLP-1')">
                                <div>
                                    <div class="text-block-545" style="color:#000">NO, I DO NOT consent to being treated with a GLP-1</div>
                                </div>
                            </a>
                        </div>
                        <!-- Single Option/Radio Questions -->
                        <div class="felix-form-block w-form" v-if="currentQuestion.question_type === 'single_option'">
                            <form>
                                <a href="#" v-for="option in currentQuestion.options" :key="option.title" :class="{'selected': isOptionSelected(option.title)}" @click.prevent="handleAnswerSingle(option)" class="link-block-30 w-inline-block">
                                    <div>
                                        <div class="text-block-545" style="color: black;">{{option.title}}</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">-></div>
                                    </div>
                                </a>
                            </form>
                        </div>
                        <div class="felix-form-block w-form" v-if="currentQuestion.question_type === 'dose_optimization'">
                            <div class="w-form">
                                <form>
                                    <div class="div-block-1977">
                                        <div class="dose-sched-box" v-for="(month, index) in months" :key="`month-${index}`">
                                            <div class="text-block-1241">MONTH {{ index + 1 }}</div>
                                            <select v-model="selectedDoses[index]" class="select-field-10 w-select">
                                                <option :value="null" disabled>MONTH {{ index + 1 }}</option>
                                                <option v-for="option in getDoseOptions(index)" :key="option.value" :value="option.value">
                                                    {{ option.label }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <button type="button" class="form-button w-button balugabtn" @click="handleNext" :disabled="!selectedDoses.every(dose => dose !== null && dose !== undefined)">
                                        Next ->
                                    </button>
                                </form>
                            </div>
                        </div>

                        <!-- Multiple Option/Checkbox Questions -->
                        <div class="felix-form-block w-form" v-if="currentQuestion.question_type === 'multiple_option'">
                            <label class="w-checkbox checkbox-field-15 w-clearfix" v-for="option in currentQuestion.options" :key="option"> &nbsp;&nbsp;
                                <input type="checkbox" :value="option.title" :checked="isOptionSelected(option)" @change="handleCheckboxChange($event, option.title)" class="w-checkbox-input checkbox-11">
                                <span class="checkbox-label-12 w-form-label">{{option.title}}</span>
                            </label>
                            <button v-if="canProceed" @click="handleNext" class="form-button w-button balugabtn">
                                Next ->
                            </button>
                        </div>

                        <!-- Text Input -->
                        <div class="felix-form-block w-form" v-if="['text', 'textarea'].includes(currentQuestion.question_type)">
                            <div class="condition-question mb-4">
                                <textarea v-model="currentAnswer" :placeholder="currentQuestion.placeholder || currentQuestion.sublabel || 'Enter your answer here'" class="textarea w-input" @input="handleTextInput" @keydown.enter.prevent rows="3">
                            </textarea>
                            </div>
                            <button type="button" class="form-button w-button balugabtn" @click="handleNext" :class="{ 'next-button-enabled': canProceed }" :disabled="!canProceed">
                                Next ->
                            </button>
                        </div>

                        <div class="felix-form-block w-form" v-if="['string', 'integer'].includes(currentQuestion.question_type)">
                            <div class="condition-question mb-4">
                                <input type="text" v-model="currentAnswer" :placeholder="currentQuestion.placeholder || currentQuestion.sublabel || 'Enter your answer here'" class="enroll-form-text-field weight w-input" @input="handleTextInput" @keydown.enter.prevent rows="3">
                            </div>
                            <button type="button" class="form-button w-button balugabtn" @click="handleNext" :class="{ 'next-button-enabled': canProceed }" :disabled="!canProceed">
                                Next ->
                            </button>
                        </div>

                        <div class="felix-form-block w-form" v-if="currentQuestion.question_type==='dose_radio_more'">
                            <form>
                                <a href="#" class="link-block-30 w-inline-block" v-for="option in currentQuestion.show_array" :key="option.sub_txt" @click.prevent="handleAnswer(option.baluga_ques)">
                                    <div class="div-block-1976">
                                        <div class="text-block-1239" v-html="option.main_txt"></div>
                                        <div class="text-block-1240" v-html="option.sub_txt"></div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">-&gt;</div>
                                    </div>
                                </a>
                            </form>
                        </div>

                        <!-- File Upload -->
                        <div class="felix-form-block w-form" v-if="currentQuestion.question_type === 'image_upload' || currentQuestion.question_type === 'file'">
                            <ImageUploader :idOfForm="form_id" :image-type="currentQuestion.question" :question-id="parseInt(currentQuestion.id)" @image-uploaded="handleImageUploaded" />
                        </div>

                        <!-- Informational -->
                        <div v-if="currentQuestion.question_type === 'informational'" class="info-message">
                            
                            <button v-if="currentQuestion.has_next_button !== false" @click="handleNext" class="form-button w-button balugabtn">
                                Next ->
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div style="height: 340px;"></div>
</div>
</template>

<script>

import ImageUploader from "../common/imageUploadS3Box.vue"
import {
    getProductById
} from '@/utils/productData'
import {
    mapGetters
} from 'vuex';

const checkOptionProperties = (question, answer) => {
    if (!question.options || !answer) return {
        important: false,
        is_critical: false
    };
    // Handle multiple choice answers
    if (Array.isArray(answer)) {
        return answer.reduce((acc, selectedAnswer) => {
            const option = question.options.find(opt => opt.title === selectedAnswer);
            if (option) {
                return {
                    important: acc.important || option.important || false,
                    is_critical: acc.is_critical || option.is_critical || false
                };
            }
            return acc;
        }, {
            important: false,
            is_critical: false
        });
    }

    // Handle single choice answers
    const option = question.options?.find(opt => opt.title === answer);
    return {
        important: option?.important || false,
        is_critical: option?.is_critical || false
    };
};

export default {
    name: 'DynamicQuestionnaire',
    props: {
        
    },
    components: {
        ImageUploader,
    },
    data() {
        return {
            currentQuestionIndex: 0,
            userState: '',
            answers: {},
            multipleChoiceAnswers: {},
            productPurchased: '',
            gettingDetails: true,
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            currentAnswer: '',
            questions: [],
            submitting: false,
            showDisqualify: false,
            disqualifyMessage: '',
            uploadedFile: null,
            dependencies: [],
            adjustmentType: "",
            months: ["Month 1", "Month 2", "Month 3"],
            drugs: {
                semaglutide: [{
                        strength: 0.25,
                        label: '0.25mg (Starting Dose)'
                    },
                    {
                        strength: 0.5,
                        label: '0.5mg'
                    },
                    {
                        strength: 1.0,
                        label: '1.0mg'
                    },
                    {
                        strength: 1.7,
                        label: '1.7mg'
                    },
                    {
                        strength: 2.4,
                        label: '2.4mg'
                    }
                ],
                tirzepatide: [{
                        strength: 2.5,
                        label: '2.5mg (Starting Dose)'
                    },
                    {
                        strength: 5.0,
                        label: '5.0mg'
                    },
                    {
                        strength: 7.5,
                        label: '7.5mg'
                    },
                    {
                        strength: 10.0,
                        label: '10.0mg'
                    },
                    {
                        strength: 12.5,
                        label: '12.5mg'
                    },
                    {
                        strength: 15.0,
                        label: '15.0mg'
                    }
                ]
            },
            selectedDrug: null,
            selectedDoses: Array(3).fill(null)
        }
    },

    computed: {
        ...mapGetters(['user']),
        currentQuestion() {
            return this.questions[this.currentQuestionIndex] || null
        },
        form_id() {
            return this.$route.params.id;
        },
        canProceed() {
            if (!this.currentQuestion) return false

            const answer = this.getCurrentAnswer()

            switch (this.currentQuestion.question_type) {
                case 'single_option':
                    return !!answer
                case 'multiple_option':
                    return Array.isArray(answer) && answer.length > 0
                case 'text':
                case 'string':
                case 'textarea':
                    return !!answer && answer.trim().length > 0
                case 'integer':
                    return !isNaN(answer) && answer !== null && answer !== ''
                case 'file':
                case 'image_upload':
                    return this.currentQuestion.is_optional || !!answer
                case 'informational':
                    return true
                case 'dose_optimization':
                    return this.selectedDoses.length === 3 && this.selectedDoses.every(dose => dose !== null)
                default:
                    return true
            }
        },

    },

    watch: {
        currentQuestionIndex: {
            handler() {
                this.scrolltoTop();
                if (this.currentQuestion && this.currentQuestion.important) {
                    this.validateAnswers();
                }
            }
        },
    },

    created() {
        this.getOrder();
        this.initializeQuestions();
        
    },

    methods: {
        goBack() {
            // If we're at the first question, there's nowhere to go back to
            if (this.currentQuestionIndex <= 0) {
                return;
            }

            // Clear current question's answer
            if (this.currentQuestion) {
                // Handle multiple choice answers
                if (this.currentQuestion.question_type === 'multiple_option') {
                    this.$delete(this.multipleChoiceAnswers, this.currentQuestion.id);
                }
                
                // Clear the current answer in both places it might be stored
                this.$delete(this.answers, this.currentQuestion.id);
                this.currentAnswer = '';

                // Clear selected doses if we're going back from dose optimization
                if (this.currentQuestion.question_type === 'dose_optimization') {
                    this.selectedDoses = Array(3).fill(null);
                }
            }

            // Find the previous question
            let previousIndex = this.currentQuestionIndex - 1;
            
            // Skip back past any hidden questions
            while (previousIndex >= 0 && !this.shouldShowQuestion(this.questions[previousIndex])) {
                previousIndex--;
            }

            // If we're going back from a follow-up question, go back to the parent question
            const currentQuestion = this.questions[this.currentQuestionIndex];
            if (currentQuestion.isFollowUp) {
                // Find the parent question's index
                const parentIndex = this.questions.findIndex(q => q.id === currentQuestion.parentId);
                if (parentIndex !== -1) {
                    previousIndex = parentIndex;
                }

                // Remove all follow-up questions related to this parent
                this.questions = this.questions.filter(q => !q.isFollowUp || q.parentId !== currentQuestion.parentId);
            }

            // Update the current index
            if (previousIndex >= 0) {
                this.currentQuestionIndex = previousIndex;
            }
        },
        async getOrder() {
            try {
                const response = await this.$axios.get(`${process.env.VUE_APP_API_ENDPOINT}/forms/orders/${this.$route.params.id}`);
                if (response.data.status === 'success' && response.data.order.status === 'pending_approval') {
                    const product = getProductById(response.data.order.product_id)[0];
                    this.productPurchased = product.name;
                    this.gettingDetails = false;
                    this.userState = response.data.state;
                    window.scrollTo(0, 0);
                } else {
                    this.$router.push('/sorry?message=Order not found or the assessment form was already submitted. Login to your dashboard to see details.')
                }
            } catch (error) {
                console.error('Error fetching order:', error);
                this.$router.push('/sorry?message=An error occurred while fetching your order. Please try again later.')
            }
        },
        async initializeQuestions() {
            try {
                console.log('Fetching questions from S3...');
                
                const response = await fetch('https://prioritymeds.s3.us-east-1.amazonaws.com/public/assets/questions/mdWeightLossQuestions.json');

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const data = await response.json();

                // Extract the questions and dependencies safely
                let questionsArray = data.questions || [];

                // Filter out pregnancy question if user is male
                if (this.user?.gender !== 'Female') {
                    questionsArray = questionsArray.filter(question => question.id !== '0');
                }

                this.questions = questionsArray;
                this.dependencies = data.dependency || [];

                console.log('Questions loaded successfully:', this.questions);
            } catch (error) {
                console.error('Error fetching questions:', error);
            }
        },

        getDoseOptions(monthIndex) {
            try {
                if (!this.selectedDrug || !this.drugs[this.selectedDrug]) {
                    return [];
                }
                const availableDoses = this.drugs[this.selectedDrug];

                // For first month, check if this is a transition case
                if (monthIndex === 0) {
                    const medQuestion = this.questions.find(q => q.question === 'current_weight_meds');
                    const lastDoseQuestion = this.questions.find(q => q.id === '8_3');
                    const currentMed = this.answers[medQuestion?.id]?.toLowerCase();
                    const lastDoseTime = this.answers[lastDoseQuestion?.id];

                    if (currentMed && lastDoseTime) {
                        const currentDrugType = currentMed.includes('tirze') || currentMed.includes('mounjaro') ?
                            'tirzepatide' : 'semaglutide';

                        // Only apply transition logic if switching medications
                        if (currentDrugType !== this.selectedDrug) {
                            // If switching from Tirzepatide to Semaglutide, always return 0.25mg only
                            if (currentDrugType === 'tirzepatide' && this.selectedDrug === 'semaglutide') {
                                const startingDose = availableDoses.find(d => Math.abs(d.strength - 0.25) < 0.0001);
                                if (startingDose) {
                                    return [{
                                        label: startingDose.label || `${startingDose.strength}mg`,
                                        value: startingDose.strength
                                    }];
                                }
                            } else {
                                // For Semaglutide to Tirzepatide transitions, use existing logic
                                const currentDoseQuestion = this.questions.find(q => q.id === '8_1' || q.id === '8_2');
                                const currentDoseMatch = this.answers[currentDoseQuestion?.id]?.match(/(\d+\.?\d*)mg/);

                                if (currentDoseMatch) {
                                    const currentDose = parseFloat(currentDoseMatch[1]);
                                    const targetDose = this.getTransitionDose(currentDrugType, currentDose, lastDoseTime);

                                    const targetDoseObj = availableDoses.find(d =>
                                        Math.abs(d.strength - targetDose) < 0.0001
                                    );

                                    if (targetDoseObj) {
                                        return [{
                                            label: targetDoseObj.label || `${targetDoseObj.strength}mg`,
                                            value: targetDoseObj.strength
                                        }];
                                    }
                                }
                            }
                        }
                    }

                    // Default to all options if not a transition case
                    return availableDoses.map(drug => ({
                        label: drug.label || `${drug.strength}mg`,
                        value: drug.strength
                    }));
                }

                // For subsequent months, show adjacent options
                const prevDose = this.selectedDoses[monthIndex - 1];
                if (prevDose === null) return [];

                const currentIndex = availableDoses.findIndex(dose =>
                    Math.abs(dose.strength - prevDose) < 0.0001
                );

                if (currentIndex === -1) return [];

                const options = [];
                if (currentIndex > 0) options.push(availableDoses[currentIndex - 1]);
                options.push(availableDoses[currentIndex]);
                if (currentIndex < availableDoses.length - 1) options.push(availableDoses[currentIndex + 1]);

                return options.map(drug => ({
                    label: drug.label || `${drug.strength}mg`,
                    value: drug.strength
                }));
            } catch (error) {
                console.error('Error getting dose options:', error);
                return [];
            }
        },

        getTransitionDose(fromDrugType, fromDose, lastDoseTime) {
            const withinTwoWeeksMap = {
                'tirzepatide': {
                    2.5: 0.25, // Always start at lowest dose
                    5.0: 0.25,
                    7.5: 0.25,
                    10.0: 0.25,
                    12.5: 0.25,
                    15.0: 0.25
                },
                'semaglutide': {
                    0.25: 2.5, // S1 -> T1
                    0.5: 2.5, // S2 -> T1
                    1.0: 5.0, // S3 -> T2
                    1.7: 7.5, // S4 -> T3
                    2.0: 7.5, // S5 -> T3
                    2.4: 10.0, // S5 -> T3
                    2.5: 10.0 // S6 -> T4
                }
            };

            const afterTwoWeeksMap = {
                'tirzepatide': {
                    2.5: 0.25, // Always start at lowest dose
                    5.0: 0.25,
                    7.5: 0.25,
                    10.0: 0.25,
                    12.5: 0.25,
                    15.0: 0.25
                },
                'semaglutide': {
                    0.25: 2.5, // S1 -> T1
                    0.5: 2.5, // S2 -> T1
                    1.0: 5.0, // S3 -> T2
                    1.7: 5.0, // S4 -> T2
                    2.0: 7.5, // S5 -> T3
                    2.4: 7.5, // S5 -> T3
                    2.5: 7.5 // S6 -> T3
                }
            };

            const moreThanMonthMap = {
                'tirzepatide': {
                    2.5: 0.25, // Always start at lowest dose (S1)
                    5.0: 0.25,
                    7.5: 0.25,
                    10.0: 0.25,
                    12.5: 0.25,
                    15.0: 0.25
                },
                'semaglutide': {
                    0.25: 2.5, // Always start at lowest dose (T1)
                    0.5: 2.5,
                    1.0: 2.5,
                    1.7: 2.5,
                    2.0: 2.5,
                    2.4: 2.5,
                    2.5: 2.5
                }
            };
            let transitionMap;
            if (lastDoseTime === 'More than a month ago') {
                transitionMap = moreThanMonthMap;
            } else if (lastDoseTime === 'Within last 2 weeks') {
                transitionMap = withinTwoWeeksMap;
            } else {
                transitionMap = afterTwoWeeksMap;
            }
            const targetDose = transitionMap[fromDrugType][fromDose] ||
                (this.selectedDrug === 'tirzepatide' ? 2.5 : 0.25); // Default to starting dose

            return targetDose;
        },

        initializeDoses() {
            // Find current medication
            const medQuestion = this.questions.find(q => q.question === 'current_weight_meds');
            if (!medQuestion) {
                return;
            }
            const currentMed = this.answers[medQuestion.id]?.toLowerCase();
            if (!currentMed) {
                this.selectedDrug = null;
                this.selectedDoses = [null, null, null];
                return;
            }
            // Set selected drug based on product bought
            this.selectedDrug = this.productPurchased.toLowerCase().includes('sema') ? 'semaglutide' : 'tirzepatide';
            // Get current medication dose
            const isDoseTirzepatide = currentMed.includes('tirze') || currentMed.includes('mounjaro');
            const doseQuestionId = isDoseTirzepatide ? '8_2' : '8_1';
            const currentDoseQuestion = this.questions.find(q => q.id === doseQuestionId);
            if (!currentDoseQuestion || !this.answers[currentDoseQuestion.id]) {
                return;
            }
            // Parse dose value
            const doseAnswer = this.answers[currentDoseQuestion.id];
            const doseMatch = doseAnswer.match(/(\d+\.?\d*)/);
            if (!doseMatch) {
                return;
            }
            const currentDose = parseFloat(doseMatch[1]);
            const currentDrugType = currentMed.includes('tirze') || currentMed.includes('mounjaro') ?
                'tirzepatide' : 'semaglutide';

            // Get last dose timing and preference
            const lastDoseDateQuestion = this.questions.find(q => q.id === '8_3');
            const lastDoseDate = this.answers[lastDoseDateQuestion?.id];
            const preferenceQuestion = this.questions.find(q => q.id === '10_1');
            const preference = this.answers[preferenceQuestion?.id];
            if (!lastDoseDate || !preference) {
                return;
            }
            // Handle same drug vs transition
            if (currentDrugType === this.selectedDrug) {
                this.handleSameDrugDoses(currentDose, preference);
            } else {
                const targetDose = this.getTransitionDose(currentDrugType, currentDose, lastDoseDate);
                this.setDoseProgression(targetDose, preference);
            }
        },

        handleSameDrugDoses(currentDose, preference) {
            const availableDoses = this.drugs[this.selectedDrug];
            const currentDoseIndex = availableDoses.findIndex(dose =>
                Math.abs(dose.strength - currentDose) < 0.0001
            );

            if (currentDoseIndex === -1) return;

            switch (preference) {
                case 'increase': {
                    const startIndex = Math.min(currentDoseIndex + 1, availableDoses.length - 1);
                    this.selectedDoses = [
                        availableDoses[startIndex].strength,
                        availableDoses[Math.min(startIndex + 1, availableDoses.length - 1)].strength,
                        availableDoses[Math.min(startIndex + 2, availableDoses.length - 1)].strength
                    ];
                    break;
                }
                case 'same':
                    this.selectedDoses = [
                        availableDoses[currentDoseIndex].strength,
                        availableDoses[currentDoseIndex].strength,
                        availableDoses[currentDoseIndex].strength
                    ];
                    break;
                case 'decrease': {
                    const decreaseIndex = Math.max(currentDoseIndex - 1, 0);
                    this.selectedDoses = [
                        availableDoses[decreaseIndex].strength,
                        availableDoses[decreaseIndex].strength,
                        availableDoses[decreaseIndex].strength
                    ];
                    break;
                }
                default:
                    this.selectedDoses = [null, null, null];
            }
        },

        setDoseProgression(initialDose, preference) {
            const availableDoses = this.drugs[this.selectedDrug];
            const startIndex = availableDoses.findIndex(dose =>
                Math.abs(dose.strength - initialDose) < 0.0001
            );

            if (startIndex === -1) {
                this.selectedDoses = [null, null, null];
                return;
            }

            switch (preference) {
                case 'increase': {
                    this.selectedDoses = [
                        availableDoses[startIndex].strength,
                        availableDoses[Math.min(startIndex + 1, availableDoses.length - 1)].strength,
                        availableDoses[Math.min(startIndex + 2, availableDoses.length - 1)].strength
                    ];
                    break;
                }
                case 'same':
                    this.selectedDoses = [
                        availableDoses[startIndex].strength,
                        availableDoses[startIndex].strength,
                        availableDoses[startIndex].strength
                    ];
                    break;
                case 'decrease': {
                    const decreaseIndex = Math.max(startIndex - 1, 0);
                    this.selectedDoses = [
                        availableDoses[decreaseIndex].strength,
                        availableDoses[decreaseIndex].strength,
                        availableDoses[decreaseIndex].strength
                    ];
                    break;
                }
                default:
                    this.selectedDoses = [null, null, null];
            }

            console.log(JSON.stringify(this.selectedDoses))
        },

        getCurrentAnswer() {
            if (!this.currentQuestion) return null
            return this.currentQuestion.question_type === 'multiple_option' ?
                this.multipleChoiceAnswers[this.currentQuestion.id] :
                this.currentAnswer || this.answers[this.currentQuestion.id]
        },

        isOptionSelected(option) {
            const answer = this.getCurrentAnswer()
            return Array.isArray(answer) ? answer.includes(option) : answer === option
        },

        handleCheckboxChange(event, option) {
            const questionId = this.currentQuestion.id
            let answers = [...(this.multipleChoiceAnswers[questionId] || [])]

            if (event.target.checked) {
                if (option.toLowerCase().includes('none')) {
                    answers = [option]
                } else {
                    answers = answers.filter(a => !a.toLowerCase().includes('none'))
                    answers.push(option)
                }
            } else {
                answers = answers.filter(a => a !== option)
            }

            this.$set(this.multipleChoiceAnswers, questionId, answers)
            this.$set(this.answers, questionId, answers)
        },
        handleAnswerSingle(option){
            if(option.is_back_button){
                this.goBack();
            }else{
                this.handleAnswer(option.title)
            }
        },
        handleAnswer(answer) {
            if (!this.currentQuestion) return
            this.$set(this.answers, this.currentQuestion.id, answer)
            this.currentAnswer = answer
            if (this.currentQuestion.question === 'next_dose_preference') {
                console.log("this is the current question ")
                this.initializeDoses();
            }
            this.moveToNextQuestion()
        },

        handleImageUploaded(data) {
            this.$set(this.answers, this.currentQuestion.id, data.base64)
            this.moveToNextQuestion()
        },

        handleNext() {
            if (!this.canProceed) return
            const answer = this.getCurrentAnswer()
            this.$set(this.answers, this.currentQuestion.id, answer)
            this.moveToNextQuestion()
        },

        handleTextInput(event) {
            this.currentAnswer = event.target.value
        },

        handleFileUpload(event) {
            const file = event.target.files[0]
            if (!file) return
            this.uploadedFile = file.name
            if (this.isImageFile(file.name)) {
                const reader = new FileReader()
                reader.onload = e => {
                    this.currentAnswer = e.target.result
                }
                reader.readAsDataURL(file)
            } else {
                this.currentAnswer = file
            }
        },

        isImageFile(name) {
            return typeof name === 'string' && /\.(jpg|jpeg|png|gif)$/i.test(name)
        },

        getFileName(file) {
            return file instanceof File ? file.name : 'File selected'
        },

        disqualifyUserAndRefund() {
            this.$emit('disqualify-user')
        },

        findNextQuestion() {
            if (!this.currentQuestion) return null
            const currentId = this.currentQuestion.id

            // Handle multiple choice questions with follow-ups
            if (this.currentQuestion.question_type === 'multiple_option' &&
                !this.currentQuestion.isFollowUp &&
                this.currentQuestion.followup_questions) {

                const selectedAnswers = this.multipleChoiceAnswers[currentId] || []
                if (selectedAnswers.length === 1 && selectedAnswers[0].toLowerCase().includes('none')) {
                    return this.findNextMainQuestion()
                }

                let insertedFollowUps = false
                const currentIndex = this.questions.findIndex(q => q.id === currentId)
                this.questions = this.questions.filter(q => !q.isFollowUp || q.parentId !== currentId)

                const allFollowUps = []
                selectedAnswers.forEach((answer, index) => {
                    const followUp = this.currentQuestion.followup_questions[answer]
                    if (followUp && !this.answers[followUp.id]) {
                        allFollowUps.push({
                            ...followUp,
                            parentId: currentId,
                            parentAnswer: answer,
                            isFollowUp: true,
                            order: index
                        })
                        insertedFollowUps = true
                    }
                })

                if (insertedFollowUps) {
                    this.questions.splice(currentIndex + 1, 0, ...allFollowUps)
                    return currentIndex + 1
                }
            }

            if (this.currentQuestion.isFollowUp) {
                const currentIndex = this.currentQuestionIndex
                const nextQuestion = this.questions[currentIndex + 1]
                if (nextQuestion?.isFollowUp && nextQuestion.parentId === this.currentQuestion.parentId) {
                    return currentIndex + 1
                }
            }

            return this.findNextMainQuestion()
        },

        findNextMainQuestion() {
            for (let i = this.currentQuestionIndex + 1; i < this.questions.length; i++) {
                const question = this.questions[i]
                if (!question.isFollowUp && this.shouldShowQuestion(question)) {
                    return i
                }
            }
            return null
        },

        moveToNextQuestion() {
            if (this.currentQuestion) {
                const answer = this.getCurrentAnswer()
                this.$set(this.answers, this.currentQuestion.id, answer)
            }

            const nextIndex = this.findNextQuestion()
            if (nextIndex !== null) {
                this.currentQuestionIndex = nextIndex
                this.currentAnswer = ''
            } else {
                const allAnswered = this.verifyAllFollowupsComplete()
                if (allAnswered) {
                    this.submitting = true
                    this.handleFinalSubmit()
                }
            }
        },

        async handleFinalSubmit() {
            this.submitting = true;
            const submissionData = {
                ...this.formatAnswers(),
                form_id: this.$route.params.id,
                userInfo: this.user
            };

            try {
                await this.$axios.post(`${this.baseUrl}/api/submit-md-form`, submissionData);
                this.submitting = false;
                this.$router.push('/home');
            } catch (error) {
                console.log(error)
                this.submitting = false;
            }

        },

        // Main formatAnswers function
        formatAnswers() {
            const formattedAnswers = [];
            const images = [];
            const processedFollowUps = new Set(); // Track processed follow-up questions
            const additional_details = {
                allergies: '',
                current_meds: '',
                current_medical_condition: '',
                pregnancy: false
            };

            if (this.user?.gender === 'Female' && this.answers['0']) {
                additional_details.pregnancy = this.answers['0'] === 'Yes';
            }
            if (this.answers['21_1']) {
                if (this.answers['21_1'] === 'No - I affirm I have no known drug allergies') {
                    additional_details.allergies = this.answers['21_1'];
                } else if (this.answers['21_2']) {
                    additional_details.allergies = this.answers['21_2'];
                }
            }

            // Handle current medications
            if (this.answers['7_3']) {
                if (this.answers['7_3'] === "No - I affirm I'm not taking any medications") {
                    additional_details.current_meds = this.answers['7_3'];
                } else if (this.answers['7_4']) {
                    additional_details.current_meds = this.answers['7_4'];
                }
            }

            // Handle medical conditions
            if (this.answers['7_1']) {
                if (this.answers['7_1'] === 'No - I affirm I have no known medical conditions') {
                    additional_details.current_medical_condition = this.answers['7_1'];
                } else if (this.answers['7_2']) {
                    additional_details.current_medical_condition = this.answers['7_2'];
                }
            }
            const excludedQuestionIds = ['0','21_1', '21_2', '7_3', '7_4', '7_1', '7_2'];
            // Process main questions
            this.questions.forEach(question => {
                if (excludedQuestionIds.includes(question.id) || !this.shouldShowQuestion(question)) {
                    return;
                }
                // Skip follow-up questions as they'll be handled separately
                if (question.isFollowUp) return;

                let answer = this.answers[question.id];
                if (answer === undefined) return;
                if (question.question_type === 'dose_optimization') return;

                // Handle dose radio more questions
                if (question.question_type === 'dose_radio_more') {
                    switch (this.answers[question.id]) {
                        case 'decrease':
                            answer = 'Decrease dose';
                            break;
                        case 'same':
                            answer = 'Stay at the same dose or equivalent dose';
                            break;
                        default:
                            answer = 'Increase the dose if a higher one is available, or continue with my current dose if its already at the maximum';
                    }
                }
                const {
                    important,
                    is_critical
                } = checkOptionProperties(question, answer);
                // Create formatted answer object
                const formattedAnswer = {
                    question: question.label,
                    answer: this.formatAnswerValue(answer),
                    type: this.determineAnswerType(question, answer),
                    description: question.description || '',
                    important: important || question.important || false,
                    is_critical: is_critical || question.is_critical || false,
                    label: question.label || '',
                    displayed_options: this.getDisplayedOptions(question)
                };

                // Handle image uploads separately
                if (formattedAnswer.type === 'image_upload') {
                    formattedAnswer.question = question.question;
                    images.push(formattedAnswer);
                } else {
                    formattedAnswers.push(formattedAnswer);
                }

                // Process follow-up questions if they exist
                if (question.followup_questions && this.multipleChoiceAnswers[question.id]) {
                    this.formatFollowupAnswers(
                        question,
                        this.multipleChoiceAnswers[question.id],
                        formattedAnswers,
                        processedFollowUps
                    );
                }
            });

            return {
                answers: formattedAnswers,
                images: images,
                patientPreference: this.selectedDoses,
                additional_details: additional_details
            };
        },

        // Helper function to format follow-up answers
        formatFollowupAnswers(parentQuestion, selectedOptions, formattedAnswers, processedFollowUps) {
            selectedOptions.forEach(option => {
                const followup = parentQuestion.followup_questions[option];

                // Skip if no followup or no answer
                if (!followup || !this.answers[followup.id]) return;

                // Skip if this follow-up has already been processed
                if (processedFollowUps.has(followup.id)) return;

                // Create follow-up answer object
                const followupAnswer = {
                    question: followup.label,
                    answer: this.formatAnswerValue(this.answers[followup.id]),
                    type: this.determineAnswerType(followup, this.answers[followup.id]),
                    description: followup.description || '',
                    label: followup.label || '',
                    important: followup.important,
                    is_critical: followup.is_critical,
                    metadata: `followup_to_${parentQuestion.id}_for_${option}`,
                    displayed_options: this.getDisplayedOptions(followup)
                };

                // Add to formatted answers and mark as processed
                formattedAnswers.push(followupAnswer);
                processedFollowUps.add(followup.id);
            });
        },

        // Helper function to format answer value
        formatAnswerValue(answer) {
            if (Array.isArray(answer)) {
                return answer.join('\n');
            }
            return String(answer);
        },

        // Helper function to determine answer type
        determineAnswerType(question, answer) {
            switch (question.question_type) {
                case 'single_option':
                case 'multiple_option':
                case 'text':
                case 'textarea':
                case 'string':
                    return 'string';
                case 'integer':
                    return 'number';
                case 'file':
                case 'image_upload':
                    return 'image_upload';
                default:
                    return typeof answer;
            }
        },

        // Helper function to get displayed options
        getDisplayedOptions(question) {
            if (question.options && Array.isArray(question.options)) {
                return question.options.map(option => option.title);
            }
            return [];
        },

        validateAllAnswers() {
            const requiredQuestions = this.questions.filter(q =>
                !q.is_optional && this.shouldShowQuestion(q)
            );

            return requiredQuestions.every(question => {
                const answer = this.answers[question.id];
                return !(answer === undefined || answer === '' ||
                    (Array.isArray(answer) && answer.length === 0));
            });
        },
        verifyAllFollowupsComplete() {
            for (const question of this.questions) {
                if (question.question_type === 'multiple_option' &&
                    question.followup_questions &&
                    !question.isFollowUp) {

                    const selectedAnswers = this.multipleChoiceAnswers[question.id] || []

                    if (selectedAnswers.length === 1 && selectedAnswers[0].toLowerCase().includes('none')) {
                        continue
                    }

                    const requiredCount = selectedAnswers.reduce((count, answer) => {
                        return count + (question.followup_questions[answer] ? 1 : 0)
                    }, 0)

                    const answeredCount = selectedAnswers.reduce((count, answer) => {
                        const followUp = question.followup_questions[answer]
                        return count + (followUp && this.answers[followUp.id] ? 1 : 0)
                    }, 0)

                    if (answeredCount < requiredCount) {
                        const nextIndex = this.findNextQuestion()
                        if (nextIndex !== null) {
                            this.currentQuestionIndex = nextIndex
                            this.currentAnswer = ''
                        }
                        return false
                    }
                }
            }
            return true
        },

        shouldShowQuestion(question) {
            // Skip Florida Bill of Rights question if user is not in Florida
            if (question.question === 'florida_bill_of_rights' && this.userState && this.userState.toLowerCase() !== 'fl' && this.userState.toLowerCase() !== 'florida') {
                return false;
            }

            if (question.isFollowUp) {
                return true
            }

            const deps = this.dependencies.filter(d => d.question_id === question.id)
            if (!deps.length) return true

            return deps.every(dep => {
                const parentAnswer = this.answers[dep.dependent_on]
                if (!parentAnswer) return false

                if (Array.isArray(parentAnswer)) {
                    return parentAnswer.some(answer => dep.ask_if_val_in.includes(answer))
                }

                return dep.ask_if_val_in.includes(parentAnswer)
            })
        },

        validateAnswers() {
            const currentQuestion = this.currentQuestion;
            if (!currentQuestion) return true;

            if (currentQuestion.question_type === 'single_option') {
                const currentAnswer = this.getCurrentAnswer();
                const hasFollowup = this.dependencies.some(dep =>
                    dep.dependent_on === currentQuestion.id &&
                    dep.ask_if_val_in.includes(currentAnswer)
                );

                if (hasFollowup) {
                    return true;
                }
            }

            if (['text', 'textarea', 'image_upload'].includes(currentQuestion.question_type)) {
                return true;
            }

            if (currentQuestion.question_type === 'informational' && currentQuestion.has_next_button === false) {
                this.disqualifyMessage = currentQuestion.description || 'We cannot proceed with your application at this time.';
                this.showDisqualify = true;
                return false;
            }

            const relatedDependencies = this.dependencies.filter(dep =>
                dep.question_id === currentQuestion.id ||
                dep.dependent_on === currentQuestion.id
            );

            for (const dep of relatedDependencies) {
                const parentAnswer = this.answers[dep.dependent_on];
                if (!parentAnswer) continue;

                const answers = Array.isArray(parentAnswer) ? parentAnswer : [parentAnswer];
                if (!this.isFollowupDependency(dep)) {
                    const matchesDisqualifyingCondition = answers.some(answer =>
                        dep.ask_if_val_in.includes(answer)
                    );

                    if (matchesDisqualifyingCondition) {
                        const relatedQuestion = this.questions.find(q => q.id === dep.question_id);
                        if (relatedQuestion?.description) {
                            this.disqualifyMessage = relatedQuestion.description;
                            this.showDisqualify = true;
                            return false;
                        }
                    }
                }
            }

            return true;
        },

        isFollowupDependency(dependency) {
            const dependentQuestion = this.questions.find(q => q.id === dependency.question_id);
            const parentQuestion = this.questions.find(q => q.id === dependency.dependent_on);

            return dependentQuestion && (
                dependentQuestion.question_type === 'text' ||
                dependentQuestion.question_type === 'textarea' ||
                dependentQuestion.question_type === 'image_upload' ||
                (parentQuestion && parentQuestion.followup_questions)
            );
        },

        scrolltoTop() {
            window.scrollTo(0, 0);
        }
    }
}
</script>

<style scoped>
.selected {
    background-color: #f0f0f0;
}

.file-upload-container {
    margin-bottom: 1rem;
}

.file-preview {
    margin-top: 1rem;
}

.image-preview {
    max-width: 200px;
    max-height: 200px;
    object-fit: contain;
}

.file-name {
    margin-top: 0.5rem;
    font-size: 0.9rem;
    color: #666;
}

.next-button-enabled {
    opacity: 1;
    cursor: pointer;
}

.next-button-enabled:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.info-message {
    padding: 1rem;
    background-color: #f8f9fa;
    border-radius: 4px;
    margin-bottom: 1rem;
}

.checkbox-field-15 {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
}

.checkbox-11 {
    margin-right: 0.5rem;
}

.acceptbutton {
    background-color: var(--light-green) !important;
    border: none;
    color: #fff
}

.rejectconbutton {
    background-color: transparent !important;
    height: 20px;
    border: none;
    text-align: center;
    justify-content: center;
}

.rejectconbutton .text-block-545 {
    font-size: 12px !important;
}

.dose-sched-box {
    width: 32%;
    padding: 10px 2px;
}

.select-field-10 {
    width: 72%;
}
@media (max-width: 768px) {
.setsizeonphone{
    max-width: 100%;
    padding-right: 10px;
    padding-left: 10px;
}
}
</style>
